import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Entity, UnallocatedUserId } from '@jms/model';
import * as Enumerable from 'linq';
import { LetterAvatar } from '../utilities';

interface UserRenderInfo {
  icon: string;
  type: 'image' | 'font';
}

@Component({
    selector: 'multiple-users',
    templateUrl: './multiple.users.component.html',
    styleUrls: ['./multiple.users.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MultipleUsersComponent implements OnInit, OnChanges {

  @Input() public limit = 4;
  @Input() public users: Entity[];
  @Input() size = 30;

  public names: UserRenderInfo[];

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes?.users && !!this.users?.length) {

      this.names = Enumerable
        .from(this.users)
        .where(x => x != null)
        .take(this.limit)
        .select(x => {

          if (x?._id === UnallocatedUserId) {
            return {
              icon: 'fa-user',
              type: 'font'
            } as UserRenderInfo;
          } else {
            return {
              icon: this.generateUserImage(x.name),
              type: 'image'
            } as UserRenderInfo;
          }
        })
        .toArray();

      if (this.users.length > this.limit) {
        const diff = this.users.length - this.limit;
        this.names.push({
          icon: LetterAvatar.generateSvgCustomDataUri(`+${diff.toString()}`, '#bbbbbb'),
          type: 'image'
        });
      }
    }
  }

  ngOnInit(): void {
  }

  public generateUserImage(userName: string) {

    if (!userName) {
      userName = 'Unknown'
    }

    const username = userName?.replace(/[0-9.]/g, '')

    return LetterAvatar.generateSvgDataUri(
      username,
      this.size
    );
  }

}
